import React from 'react';
import classNames from 'classnames';
import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';
import styles from './SessionSourceTags.module.scss';

export const SessionSourceTags = ({
  pastData,
  typeLog,
  className,
  textVariant = textVariantsEnum.Text_xxs,
}) => {
  const isOffline = pastData === true;
  const isManual =
    typeof typeLog === 'string' && typeLog.toLowerCase() === 'manual';

  if (!isOffline && !isManual) return null;

  return (
    <div className={classNames(styles.sessionTags, className)}>
      {isOffline && (
        <Text
          variant={textVariant}
          fontWeight={fontWeightEnum.SemiBold}
          className={classNames(styles.sessionTag, styles.sessionTag_offline)}
        >
          offline
        </Text>
      )}
      {isManual && (
        <Text
          variant={textVariant}
          fontWeight={fontWeightEnum.SemiBold}
          className={classNames(styles.sessionTag, styles.sessionTag_manual)}
        >
          manual
        </Text>
      )}
    </div>
  );
};
